import type { HTMLAttributes } from "react";

// Card — a token-driven surface container.
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`ui-card${className ? ` ${className}` : ""}`} {...props} />;
}
